/* ------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: team imagery in nav + on team pages.
 *  - NAV DROPDOWNS (NFL / NCAA / NLL, on hover): official team logos, next to
 *    each team link. Injected as a sitewide <style> that overrides the Zubaz
 *    patch ::before icons declared in custom-styles.css.
 *  - TEAM PAGE (collection page, after clicking a team): the Zubaz zebra patch,
 *    inline next to the <h1> team name.
 * Standalone — no dependency on custom.js, so script load order does not matter.
 * ------------------------------------------------------------------------------ */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0549/7284/2064/';

  // Zubaz zebra patches — TEAM PAGE header (next to the <h1>).
  var ICONS = {
    'arizona-cardinals': CDN + 'collections/WA_AGI-50721-S_SH11_Cardinals_Hood.png?v=1721329492',
    'atlanta-falcons': CDN + 'collections/WA_AGI-50721-S_SH11_Falcons_Hood.png?v=1721331642',
    'baltimore-ravens': CDN + 'collections/wa_agi-50721-s_sh11_ravens_hood_copy.png?v=1721331481',
    'buffalo-bills': CDN + 'collections/WA_AGI-50721-S_SH11_Bills_Hood.png?v=1721330360',
    'carolina-panthers': CDN + 'collections/wa_agi-50721-s_sh11_panthers_hood_copy.png?v=1721332172',
    'chicago-bears': CDN + 'collections/WA_AGI-50721-S_SH11_Bears_Hood.png?v=1721330215',
    'cincinnati-bengals': CDN + 'collections/WA_AGI-50721-S_SH11_Bengals_Hood.png?v=1721331338',
    'cleveland-browns': CDN + 'collections/WA_AGI-50721-S_SH11_Browns_Hood.png?v=1721331065',
    'dallas-cowboys': CDN + 'collections/WA_AGI-50721-S_SH11_dallas_copy.png?v=1721332891',
    'denver-broncos': CDN + 'collections/WA_AGI-50721-S_SH11_Broncos_Hood.png?v=1721330344',
    'detroit-lions': CDN + 'collections/WA_AGI-50721-S_SH11_Lions_Hood.png?v=1721331425',
    'green-bay-packers': CDN + 'collections/WA_AGI-50721-S_SH11_Packers_Hood.png?v=1721331547',
    'houston-texans': CDN + 'collections/wa_agi-50721-s_sh11_texans_hood_copy.png?v=1721331325',
    'indianapolis-colts': CDN + 'collections/WA_AGI-50721-S_SH11_Colts_Hood.png?v=1721331622',
    'jacksonville-jaguars': CDN + 'collections/WA_AGI-50721-S_SH11_Jaguars_Hood.png?v=1721331580',
    'kansas-city-chiefs': CDN + 'collections/WA_AGI-50721-S_SH11_Chiefs_Hood.png?v=1721330373',
    'las-vegas-raiders': CDN + 'collections/wa_agi-50721-s_sh11_raiders_hood_copy.png?v=1721331296',
    'los-angeles-chargers': CDN + 'collections/WA_AGI-50721-S_SH11_Chargers_Hood.png?v=1721331633',
    'los-angeles-rams': CDN + 'collections/wa_agi-50721-s_sh11_rams_hood_copy.png?v=1721331278',
    'miami-dolphins': CDN + 'collections/WA_AGI-50721-S_SH11_Dolphins_Hood.png?v=1721331352',
    'minnesota-vikings': CDN + 'collections/wa_agi-50721-s_sh11_vikings_hood_copy.png?v=1721331191',
    'new-england-patriots': CDN + 'collections/wa_agi-50721-s_sh11_titans_hood_copy.png?v=1721331531',
    'new-orleans-saints': CDN + 'collections/wa_agi-50721-s_sh11_saints_hood_copy.png?v=1721331365',
    'new-york-giants': CDN + 'collections/WA_AGI-50721-S_SH11_Giants_Hood.png?v=1721331503',
    'new-york-jets': CDN + 'collections/WA_AGI-50721-S_SH11_Jets_Hood.png?v=1721331203',
    'philadelphia-eagles': CDN + 'collections/WA_AGI-50721-S_SH11_Eagles_Hood.png?v=1721331309',
    'pittsburgh-steelers': CDN + 'collections/wa_agi-50721-s_sh11_steelers_hood_copy.png?v=1721331043',
    'san-francisco-49ers': CDN + 'collections/WA_AGI-50721-S_SH11_Forty9ers_Hood.png?v=1721331438',
    'seattle-seahawks': CDN + 'collections/wa_agi-50721-s_sh11_seahawks_hood_copy.png?v=1721331469',
    'tampa-bay-buccaneers': CDN + 'collections/WA_AGI-50721-S_SH11_Buccaneers_Hood.png?v=1721331410',
    'tennessee-titans': CDN + 'collections/wa_agi-50721-s_sh11_titans_hood_copy_5c5d6c6b-e668-4139-b07a-ad8b70e7cdd3.png?v=1721332234',
    'washington-commanders': CDN + 'collections/WA_AGI-50721-S_SH11_Washington_Hood_copy.png?v=1732038188',
    'auburn-tigers': CDN + 'files/zbz-patch-auburn-tigers.png?v=1781293609',
    'duke-blue-devils': CDN + 'files/zbz-patch-duke-blue-devils.png?v=1781293609',
    'georgia-tech-yellow-jackets': CDN + 'files/zbz-patch-georgia-tech-yellow-jackets.png?v=1781293609',
    'iowa-hawkeyes': CDN + 'files/zbz-patch-iowa-hawkeyes.png?v=1781293609',
    'kansas-jayhawks': CDN + 'files/zbz-patch-kansas-jayhawks-v3.png?v=1781454473',
    'lsu-tigers': CDN + 'files/zbz-patch-lsu-tigers.png?v=1781293609',
    'missouri-tigers': CDN + 'files/zbz-patch-missouri-tigers.png?v=1781293609',
    'oregon-ducks': CDN + 'files/zbz-patch-oregon-ducks.png?v=1781293609',
    'oregon-state-beavers': CDN + 'files/zbz-patch-oregon-state-beavers-v3.png?v=1781454473',
    'purdue-boilermakers': CDN + 'files/zbz-patch-purdue-boilermakers.png?v=1781293609',
    'syracuse-orange': CDN + 'files/zbz-patch-syracuse-orange.png?v=1781293609',
    'tcu-horned-frogs': CDN + 'files/zbz-patch-tcu-horned-frogs.png?v=1781293609',
    'west-virginia-mountaineers': CDN + 'files/zbz-patch-west-virginia-mountaineers-v3.png?v=1781454475',
    'buffalo-bandits': CDN + 'files/zbz-patch-buffalo-bandits.png?v=1781297494',
  };

  // Official team logos (self-hosted) — NAV DROPDOWNS (next to each team link).
  var NAV_LOGOS = {
    'arizona-cardinals': CDN + 'files/zbz-logo-arizona-cardinals.png',
    'atlanta-falcons': CDN + 'files/zbz-logo-atlanta-falcons.png',
    'baltimore-ravens': CDN + 'files/zbz-logo-baltimore-ravens.png',
    'buffalo-bills': CDN + 'files/zbz-logo-buffalo-bills.png',
    'carolina-panthers': CDN + 'files/zbz-logo-carolina-panthers.png',
    'chicago-bears': CDN + 'files/zbz-logo-chicago-bears.png',
    'cincinnati-bengals': CDN + 'files/zbz-logo-cincinnati-bengals.png',
    'cleveland-browns': CDN + 'files/zbz-logo-cleveland-browns.png',
    'dallas-cowboys': CDN + 'files/zbz-logo-dallas-cowboys.png',
    'denver-broncos': CDN + 'files/zbz-logo-denver-broncos.png',
    'detroit-lions': CDN + 'files/zbz-logo-detroit-lions.png',
    'green-bay-packers': CDN + 'files/zbz-logo-green-bay-packers.png',
    'houston-texans': CDN + 'files/zbz-logo-houston-texans.png',
    'indianapolis-colts': CDN + 'files/zbz-logo-indianapolis-colts.png',
    'jacksonville-jaguars': CDN + 'files/zbz-logo-jacksonville-jaguars.png',
    'kansas-city-chiefs': CDN + 'files/zbz-logo-kansas-city-chiefs.png',
    'las-vegas-raiders': CDN + 'files/zbz-logo-las-vegas-raiders.png',
    'los-angeles-chargers': CDN + 'files/zbz-logo-los-angeles-chargers.png',
    'los-angeles-rams': CDN + 'files/zbz-logo-los-angeles-rams.png',
    'miami-dolphins': CDN + 'files/zbz-logo-miami-dolphins.png',
    'minnesota-vikings': CDN + 'files/zbz-logo-minnesota-vikings.png',
    'new-england-patriots': CDN + 'files/zbz-logo-new-england-patriots.png',
    'new-orleans-saints': CDN + 'files/zbz-logo-new-orleans-saints.png',
    'new-york-giants': CDN + 'files/zbz-logo-new-york-giants.png',
    'new-york-jets': CDN + 'files/zbz-logo-new-york-jets.png',
    'philadelphia-eagles': CDN + 'files/zbz-logo-philadelphia-eagles.png',
    'pittsburgh-steelers': CDN + 'files/zbz-logo-pittsburgh-steelers.png',
    'san-francisco-49ers': CDN + 'files/zbz-logo-san-francisco-49ers.png',
    'seattle-seahawks': CDN + 'files/zbz-logo-seattle-seahawks.png',
    'tampa-bay-buccaneers': CDN + 'files/zbz-logo-tampa-bay-buccaneers.png',
    'tennessee-titans': CDN + 'files/zbz-logo-tennessee-titans.png',
    'washington-commanders': CDN + 'files/zbz-logo-washington-commanders.png',
    'auburn-tigers': CDN + 'files/zbz-logo-auburn-tigers.png',
    'duke-blue-devils': CDN + 'files/zbz-logo-duke-blue-devils.png',
    'georgia-tech-yellow-jackets': CDN + 'files/zbz-logo-georgia-tech-yellow-jackets.png',
    'iowa-hawkeyes': CDN + 'files/zbz-logo-iowa-hawkeyes.png',
    'kansas-jayhawks': CDN + 'files/zbz-logo-kansas-jayhawks.png',
    'lsu-tigers': CDN + 'files/zbz-logo-lsu-tigers.png',
    'missouri-tigers': CDN + 'files/zbz-logo-missouri-tigers.png',
    'oregon-ducks': CDN + 'files/zbz-logo-oregon-ducks.png',
    'oregon-state-beavers': CDN + 'files/zbz-logo-oregon-state-beavers.png',
    'purdue-boilermakers': CDN + 'files/zbz-logo-purdue-boilermakers.png',
    'syracuse-orange': CDN + 'files/zbz-logo-syracuse-orange.png',
    'tcu-horned-frogs': CDN + 'files/zbz-logo-tcu-horned-frogs.png',
    'west-virginia-mountaineers': CDN + 'files/zbz-logo-west-virginia-mountaineers.png',
    'buffalo-bandits': CDN + 'files/zbz-nav-buffalo-bandits.png',
  };

  // NCAA + NLL team colors [primary, secondary] — power the team-color
  // collection pages and team-colored confetti for those leagues (NFL teams are
  // handled by custom.js's ZUBAZ_TEAMS, which we leave NFL-only on purpose).
  var TEAM_COLORS = {
    'auburn-tigers': ['#0C2340', '#E87722'],
    'duke-blue-devils': ['#00539B', '#012169'],
    'georgia-tech-yellow-jackets': ['#003057', '#B3A369'],
    'iowa-hawkeyes': ['#000000', '#FFCD00'],
    'kansas-jayhawks': ['#0051BA', '#E8000D'],
    'lsu-tigers': ['#461D7C', '#FDD023'],
    'missouri-tigers': ['#000000', '#F1B82D'],
    'oregon-ducks': ['#154733', '#FEE123'],
    'oregon-state-beavers': ['#DC4405', '#000000'],
    'purdue-boilermakers': ['#000000', '#CEB888'],
    'syracuse-orange': ['#F76900', '#002D72'],
    'tcu-horned-frogs': ['#4D1979', '#A3A9AC'],
    'west-virginia-mountaineers': ['#002855', '#EAAA00'],
    'buffalo-bandits': ['#F47B20', '#000000'],
  };

  // Per-team patch scale (see scales{} in genteamjs.py) — equalizes the visible
  // patch size and gives full-bleed patches margin so none look cropped.
  var SCALES = {
    'arizona-cardinals': 1.0,
    'atlanta-falcons': 1.0,
    'baltimore-ravens': 1.0,
    'buffalo-bills': 1.0,
    'carolina-panthers': 1.0,
    'chicago-bears': 1.0,
    'cincinnati-bengals': 1.0,
    'cleveland-browns': 1.0,
    'dallas-cowboys': 0.999,
    'denver-broncos': 1.0,
    'detroit-lions': 1.0,
    'green-bay-packers': 1.0,
    'houston-texans': 1.0,
    'indianapolis-colts': 1.0,
    'jacksonville-jaguars': 1.0,
    'kansas-city-chiefs': 1.0,
    'las-vegas-raiders': 1.0,
    'los-angeles-chargers': 1.0,
    'los-angeles-rams': 1.0,
    'miami-dolphins': 0.889,
    'minnesota-vikings': 1.0,
    'new-england-patriots': 1.0,
    'new-orleans-saints': 1.0,
    'new-york-giants': 1.0,
    'new-york-jets': 1.0,
    'philadelphia-eagles': 1.0,
    'pittsburgh-steelers': 0.889,
    'san-francisco-49ers': 0.889,
    'seattle-seahawks': 1.0,
    'tampa-bay-buccaneers': 1.0,
    'tennessee-titans': 1.0,
    'washington-commanders': 1.0,
    'auburn-tigers': 0.803,
    'duke-blue-devils': 0.8,
    'georgia-tech-yellow-jackets': 0.8,
    'iowa-hawkeyes': 0.8,
    'kansas-jayhawks': 0.8,
    'lsu-tigers': 0.8,
    'missouri-tigers': 0.8,
    'oregon-ducks': 0.8,
    'oregon-state-beavers': 0.8,
    'purdue-boilermakers': 0.8,
    'syracuse-orange': 0.8,
    'tcu-horned-frogs': 0.8,
    'west-virginia-mountaineers': 0.8,
    'buffalo-bandits': 0.929,
  };

  // Nav dropdown (sitewide): swap the Zubaz patch ::before icons that
  // custom-styles.css sets on each team link for the official team logo.
  // Runs on EVERY page (the nav is sitewide), before the team-page early return.
  (function () {
    var css = '';
    Object.keys(NAV_LOGOS).forEach(function (h) {
      css += 'a.link--faded[href$="/collections/' + h + '"]::before,'
           + 'a.mega-menu__title[href$="/collections/' + h + '"]::before,'
           + 'a.mobile-nav__link[href$="/collections/' + h + '"]::before'
           + '{ background-image: url(' + NAV_LOGOS[h] + ') !important; }';
    });
    var s = document.createElement('style');
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  })();

  // ===== NCAA/NLL team-colored confetti (sitewide) =====
  // custom.js drives confetti two ways, both NFL-only: zubazTeamColorsFromText
  // (matches the product title on add-to-cart) and a 'zubaz:confetti' event
  // (fit-builder / quiet quick-add). Teach both about NCAA/NLL here.
  function zbzTextColor(hex) {
    var c = String(hex || '').replace('#', '');
    if (c.length !== 6) return '#ffffff';
    var r = parseInt(c.substr(0, 2), 16), g = parseInt(c.substr(2, 2), 16), b = parseInt(c.substr(4, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? '#000000' : '#ffffff';
  }
  function zbzColorsFor(handle) { return [TEAM_COLORS[handle][0], TEAM_COLORS[handle][1], '#ffffff']; }
  function zbzColorsForTitle(title) {
    var t = (title || '').toLowerCase();
    for (var h in TEAM_COLORS) {
      if (t.indexOf(h.replace(/-/g, ' ')) !== -1) return zbzColorsFor(h);
    }
    return null;
  }
  // Wrap zubazTeamColorsFromText: fall through to NCAA/NLL when NFL doesn't match.
  var zbzOrigColors = window.zubazTeamColorsFromText;
  window.zubazTeamColorsFromText = function (text) {
    var r = zbzOrigColors ? zbzOrigColors(text) : null;
    return r || zbzColorsForTitle(text);
  };
  // Capture phase runs before custom.js's (bubble) handler, so we inject the
  // NCAA/NLL colors into the event and custom.js renders them — no double burst.
  document.addEventListener('zubaz:confetti', function (e) {
    var d = e.detail || {};
    if (!d.colors && d.teamHandle && TEAM_COLORS[d.teamHandle]) d.colors = zbzColorsFor(d.teamHandle);
  }, true);

  // ===== TEAM PAGE: Zubaz patch next to the team name =====
  var match = window.location.pathname.match(/^\/collections\/([a-z0-9-]+)/);
  if (!match) return;

  var icon = ICONS[match[1]];
  if (!icon) return;

  // NCAA/NLL team colors for this page (NFL pages are colored by custom.js).
  var tcol = TEAM_COLORS[match[1]];

  function addLogo() {
    var h1 = document.querySelector('.page-header h1, #main h1, main h1');
    if (!h1 || h1.querySelector('.zubaz-team-logo')) return;

    var img = document.createElement('img');
    img.className = 'zubaz-team-logo';
    img.alt = '';
    img.setAttribute('loading', 'eager');
    img.src = icon + (icon.indexOf('?') === -1 ? '?' : '&') + 'width=220';
    // Force inline beside the title. Focal forces header images to
    // display:block with large margins (!important), which would push the
    // logo onto its own line above the name — override all of it. The per-team
    // SCALES factor equalizes the visible patch size across leagues and gives
    // full-bleed patches margin so none look cropped; box height stays uniform.
    var scale = SCALES[match[1]] || 1;
    img.style.cssText = 'display:inline-block !important;height:1.45em !important;width:auto !important;vertical-align:middle !important;margin:0 0.36em 0 0 !important;float:none !important;transform:scale(' + scale + ') !important;transform-origin:center center !important;';
    h1.insertBefore(img, h1.firstChild);
  }

  // Team-color the page (NCAA/NLL): tint the H1 + underline, drop a top stripe,
  // and recolor primary buttons — mirrors the NFL treatment custom.js applies.
  function addTeamColor() {
    if (!tcol || document.getElementById('zubaz-teamcolor-style')) return;
    var prim = tcol[0], sec = tcol[1];
    var st = document.createElement('style');
    st.id = 'zubaz-teamcolor-style';
    st.textContent =
      '#main h1, main h1 { color: ' + prim + '; display: inline-block; border-bottom: 5px solid ' + sec + '; padding-bottom: 8px; }' +
      '.zubaz-team-stripe { height: 10px; background: linear-gradient(90deg, ' + prim + ' 0 60%, ' + sec + '); }' +
      '#main .button--primary:not(.zubaz-fb__addall), main .button--primary:not(.zubaz-fb__addall) { background: ' + prim + ' !important; color: ' + zbzTextColor(prim) + ' !important; }';
    document.head.appendChild(st);
    var main = document.querySelector('main, #main');
    if (main && !main.querySelector('.zubaz-team-stripe')) {
      var stripe = document.createElement('div');
      stripe.className = 'zubaz-team-stripe';
      main.prepend(stripe);
    }
  }

  function run() { addLogo(); addTeamColor(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* ------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: personalized "Shop by Category" tiles on the league pages.
 *  /pages/nfl and /pages/ncaa each have a Focal collection-list "Shop by
 *  Category" section. This swaps each tile's image for a real product photo:
 *    - no team picked  -> a DIFFERENT team per category (variety)
 *    - NFL team picked -> that team's product in every category (updates live)
 *  NCAA is always variety (the team picker holds NFL teams only). Matching is
 *  by each product's zbz-cat-<category> tag within a team's collection; if a
 *  team has nothing in a category, falls back to any team's product from that
 *  category collection so a tile is never blank.
 * ------------------------------------------------------------------------------ */
(function () {
  var path = window.location.pathname;
  var league = path === '/pages/nfl' ? 'nfl' : (path === '/pages/ncaa' ? 'ncaa' : null);
  if (!league) return;

  var NFL = ['arizona-cardinals', 'atlanta-falcons', 'baltimore-ravens', 'buffalo-bills', 'carolina-panthers', 'chicago-bears', 'cincinnati-bengals', 'cleveland-browns', 'dallas-cowboys', 'denver-broncos', 'detroit-lions', 'green-bay-packers', 'houston-texans', 'indianapolis-colts', 'jacksonville-jaguars', 'kansas-city-chiefs', 'las-vegas-raiders', 'los-angeles-chargers', 'los-angeles-rams', 'miami-dolphins', 'minnesota-vikings', 'new-england-patriots', 'new-orleans-saints', 'new-york-giants', 'new-york-jets', 'philadelphia-eagles', 'pittsburgh-steelers', 'san-francisco-49ers', 'seattle-seahawks', 'tampa-bay-buccaneers', 'tennessee-titans', 'washington-commanders'];
  var NCAA = ['auburn-tigers', 'duke-blue-devils', 'georgia-tech-yellow-jackets', 'iowa-hawkeyes', 'kansas-jayhawks', 'lsu-tigers', 'missouri-tigers', 'oregon-ducks', 'oregon-state-beavers', 'purdue-boilermakers', 'syracuse-orange', 'tcu-horned-frogs', 'west-virginia-mountaineers'];
  var teams = league === 'nfl' ? NFL : NCAA;

  function pickedTeam() {
    if (league !== 'nfl') return null;            // picker holds NFL teams only
    try {
      var h = localStorage.getItem('zubaz-team');
      return (h && NFL.indexOf(h) !== -1) ? h : null;
    } catch (e) { return null; }
  }

  var cache = {};
  function products(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return cache[handle];
  }

  function firstImage(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].images && list[i].images[0] && list[i].images[0].src) return list[i].images[0].src;
    }
    return null;
  }

  function applyImage(img, src) {
    if (!src || !img) return;
    img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=700';
    img.srcset = '';
    img.removeAttribute('data-srcset');
  }

  function tiles() {
    var sec = document.querySelector('#main .shopify-section--collection-list');
    if (!sec) return [];
    var seen = {}, out = [];
    [].slice.call(sec.querySelectorAll('a[href*="/collections/"]')).forEach(function (a) {
      var handle = a.getAttribute('href').split('?')[0].split('/collections/')[1];
      if (!handle || seen[handle]) return;
      seen[handle] = 1;
      var scope = a.closest('.list-collections__item, li') || a.parentElement;
      var img = scope.querySelector('img');
      if (img) out.push({ handle: handle, img: img });
    });
    return out;
  }

  // Map a product title to a team handle (titles carry the full team name,
  // e.g. "...Camo Line Shorts, Auburn Tigers").
  function teamFromTitle(title) {
    var t = (title || '').toLowerCase();
    for (var i = 0; i < teams.length; i++) {
      if (t.indexOf(teams[i].replace(/-/g, ' ')) !== -1) return teams[i];
    }
    return null;
  }

  function personalize() {
    var ts = tiles();
    if (!ts.length) return;
    var picked = pickedTeam();

    if (picked) {
      // Every tile -> the picked team's product in that category (team
      // collection filtered by the zbz-cat-<category> tag). Falls back to any
      // team's product from the category collection if the team lacks it.
      ts.forEach(function (tile) {
        var tag = 'zbz-cat-' + tile.handle.replace(/^(nfl|ncaa)-/, '');
        products(picked).then(function (list) {
          var src = firstImage(list.filter(function (p) { return (p.tags || []).indexOf(tag) !== -1; }));
          if (src) { applyImage(tile.img, src); return; }
          products(tile.handle).then(function (catList) { applyImage(tile.img, firstImage(catList)); });
        });
      });
      return;
    }

    // Variety: a DIFFERENT team per category. Processed sequentially so the
    // "used" set stays consistent and teams don't repeat. For each category we
    // read its collection (all teams' products in that category), map
    // team -> first product image, then take the first not-yet-used team
    // (offset by tile index so the picks spread across teams).
    var used = {};
    (function next(i) {
      if (i >= ts.length) return;
      var tile = ts[i];
      products(tile.handle).then(function (list) {
        var byTeam = {};
        list.forEach(function (p) {
          var tm = teamFromTitle(p.title);
          if (tm && !byTeam[tm] && p.images && p.images[0]) byTeam[tm] = p.images[0].src;
        });
        var src = null, team = null, k;
        for (k = 0; k < teams.length; k++) {
          var a = teams[(i + k) % teams.length];
          if (byTeam[a] && !used[a]) { team = a; src = byTeam[a]; break; }
        }
        if (!src) {
          for (k = 0; k < teams.length; k++) {
            var b = teams[(i + k) % teams.length];
            if (byTeam[b]) { team = b; src = byTeam[b]; break; }
          }
        }
        if (!src) src = firstImage(list);
        if (team) used[team] = 1;
        applyImage(tile.img, src);
        next(i + 1);
      });
    })(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', personalize);
  } else {
    personalize();
  }
  document.addEventListener('zubaz:team', personalize);
})();
